import axios from "axios";
import axiosInstance from "./axios";
import { EncryptFE } from "./encrypt";
// const API_BASE_URL = "http://localhost:8000/api/v1";
// const API_BASE_URL = "http://178.128.215.35:8000/api/v1"
const API_BASE_URL = "https://api.soksan-dss.com/api/v1";

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  if (!token || !user) {
    return false;
  }

  try {
    const userData = JSON.parse(user);
    return !!userData;
  } catch (error) {
    return false;
  }
};

//auth apis
export const login = async (email, password, osVersion = '', browser = '') => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/admin/Login`,
      {
        EMailID: email,
        Password: password,
        OSVersion: osVersion || navigator.platform,
        Browser: browser || navigator.userAgent
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login failed:", error?.response?.data || error.message);
    throw error;
  }
};
export const getTemporaryPassword = async (userId) => {
  const token = localStorage.getItem("token");

  const response = await axiosInstance(`${API_BASE_URL}/admin/temp-password/${userId}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  return await response.data;
};

export const changePassword = async (email, oldPassword, newPassword) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/admin/Users/ChangePassword`,
      {
        EmailID: email,
        OldPassword: oldPassword,
        NewPassword: newPassword
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Change password failed:", error?.response?.data || error.message);
    throw error;
  }
};

// User Management APIs
export const getUsers = async (token) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/admin/Users/GetList`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get users failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const createUser = async (userData, token) => {
  try {
    const encryptedData = {
      Name: EncryptFE(userData.name),
      Surname: EncryptFE(userData.surname),
      EmailID: EncryptFE(userData.email),
      PhoneNumber: EncryptFE(userData.phone),
      Address: EncryptFE(userData.address),
      IsUserManagementAllowed: userData.permissions?.userManagement || false,
      IsCropManagementAllowed: userData.permissions?.cropManagement || false,
      IsReportAccessAllowed: userData.permissions?.reportAccess || false,
      IsDeleteAllowed: userData.permissions?.deleteAllowed || false,
    };
    const response = await axiosInstance.post(
      `${API_BASE_URL}/admin/Users/Insert`,
      encryptedData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(encryptedData),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Create user failed:", error?.response?.data || error.message);
    throw error;
  }
};
export const updateUser = async (userData) => {
  try {
    const encryptedData = {
      ID: userData.id,
      Name: EncryptFE(userData.name),
      Surname: EncryptFE(userData.surname),
      PhoneNumber: EncryptFE(userData.phone),
      Address: EncryptFE(userData.address),

      IsActive: userData.IsActive === true,

      IsUserManagementAllowed: userData.permissions?.userManagement || false,
      IsCropManagementAllowed: userData.permissions?.cropManagement || false,
      IsReportAccessAllowed: userData.permissions?.reportAccess || false,
      IsDeleteAllowed: userData.permissions?.deleteAllowed || false,
    };

    const response = await fetch(`${API_BASE_URL}/admin/Users/Update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(encryptedData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUser = async (userId, token) => {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/admin/Users/Delete`,
      {
        data: { ID: userId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Delete user failed:", error?.response?.data || error.message);
    throw error;
  }
};

// Disease Management APIs
export const getAllDiseases = async (token) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/auth/all-diseases`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get diseases failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const addDisease = async (token, formData) => {
  console.log("Adding disease with data:", formData);
  const res = await axiosInstance.post(
    `${API_BASE_URL}/auth/add-disease`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const updateDisease = async (token, formData) => {
  console.log("Updating disease with data:", formData);
  const res = await axiosInstance.put(
    `${API_BASE_URL}/auth/update-disease`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

// pest management apis
export const getPests = async (token) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/auth/all-pests`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get pests failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const addPest = async (token, formData) => {
  console.log("Adding pest with data:", formData);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/add-pest`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Add pest failed:", error?.response?.data || error.message);
    throw error;
  }
};


export const updatePest = async (token, formData) => {
  console.log("Updating pest with data:", formData);
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/update-pest`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update pest failed:", error?.response?.data || error.message);
    throw error;
  }
};



// crop management apis
export const getCrops = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/all-crops`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(res);
  return res.data || [];
};

export const getCropsNew = async (token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/admin/newCrop`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data || [];
  } catch (error) {
    console.error('Error fetching crops:', error);
    throw error;
  }
};

// ─── NEW: Get crop details by ID ────────────────────────────────────────
export const getCropById = async (cropId, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/admin/getCropDetails/${cropId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error('Error fetching crop details:', error);
    throw error;
  }
};

export const addCrop = async (formData, token) => {
  console.log("Adding crop with data:", formData);
  const res = await axiosInstance.post(
    `${API_BASE_URL}/crop/add-crop`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

export const updateCrop = async (formData, token) => {
  console.log("Updating crop with data api1:", formData);
  try {
    console.log("Updating crop with data api2:", formData);
    const response = await axiosInstance.post(
      `${API_BASE_URL}/crop/update-crop`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update crop failed:", error?.response?.data || error.message);
    throw error;
  }
};


//crop-pest-mapping management apis
export const getCropPestMappings = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/crop/crop-pest-mappings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(res);
  return res.data || [];
}

export const addCropPestMapping = async (token, data) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/crop/add-crop-pest-mapping`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const updateCropPestMapping = async (token, data) => {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/update-crop-pest-mapping`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating crop pest mapping:', error);
    throw error;
  }
};

export const getCropPestMappingById = async (token, id) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/crop/crop-pest-mapping/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data || null;
};


//crop-disease-mapping management apis
export const addCropDiseaseMapping = async (token, data) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/crop/add-crop-diseases-mapping`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log(data);
  return response.data;
};

export const getCropDiseaseMappings = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/crop/crop-diseases-mappings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(res);
  return res.data || [];
}
export const getCropDiseaseMappingById = async (token, id) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/crop/crop-diseases-mapping/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data || null;
};

export const updateCropDiseaseMapping = async (token, data) => {
  const response = await axiosInstance.put(`${API_BASE_URL}/crop/update-crop-diseases-mapping`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}


// translate api
export const translateData = async (payload, token) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/data-translate`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Translate Pest failed:",
      error?.response?.data || error.message
    );
    throw error;
  }
};

export const getLanguages = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/languages`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get languages failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const getGoogleLanguages = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/google-languages`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get languages failed:", error?.response?.data || error.message);
    throw error;
  }
}
export const addLanguage = async (formData, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/add-language`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding language:", error);
  }
};

export const updateLanguage = async (id, formData, token) => {
  try {
    const response = await axiosInstance.put(`${API_BASE_URL}/update-language/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating language:", error);
    throw error;
  }
};
//phases
export const getAllPhases = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/phases`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res || [];
};

export const addPhase = async (token, payload) => {
  const res = await axiosInstance.post(`${API_BASE_URL}/add-phase`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const updatePhase = async (token, payload) => {
  const res = await axiosInstance.put(`${API_BASE_URL}/update-phase`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getSubjects = async (token) => {
  console.log("Fetching subjects...");
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/subject`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    console.log("Subjects fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Get subjects failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const addSubject = async (token, formData) => {
  console.log("Adding subject with data:", formData);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/subject`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    console.log("Subject added successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Add subject failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const updateSubject = async (token, formData, id) => {
  console.log("Updating subject with data:", formData);
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/subject/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    console.log("Subject updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Update subject failed:", error?.response?.data || error.message);
    throw error;
  }
};
export const deleteSubject = async (token, id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/subject/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    )
    return response.data;
  } catch (error) {
    console.error("Delete subject failed:", error?.response?.data);
    throw error;
  }
}

export const getGeneralTopics = async (token) => {
  console.log("Fetching general topics...");
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/generalTopic`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    console.log("General topics fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Get general topics failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const addGeneralTopic = async (token, formData) => {
  console.log("Adding general topic with data:", formData);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/generalTopic`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    console.log("General topic added successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Add general topic failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const updateGeneralTopic = async (token, formData, id) => {
  console.log("Updating general topic with data:", formData);
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/generalTopic/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    console.log("General topic updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Update general topic failed:", error?.response?.data || error.message);
    throw error;
  }
};
export const deleteGeneralTopic = async (token, id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/generalTopic/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    )
    return response.data;
  } catch (error) {
    console.error("Delete general topic failed:", error?.response?.data);
    throw error;
  }
}
export const GetGeoDet = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}/GetGeographyDet`);
    return response.data;
  } catch (error) {
    console.error("Get GeoDet failed:", error?.response?.data || error.message);
    throw error;
  }
}
export const getFilteredFarmers = async (params, token) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          queryParams.append(key, value.join(','));
        } else {
          queryParams.append(key, value);
        }
      }
    });

    const url = `${API_BASE_URL}/admin/GetFarmerListWithDetail?${queryParams.toString()}`;

    const res = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data;
  } catch (error) {
    console.error("Get filtered farmers failed:", error?.response?.data || error.message);
    throw error;
  }
};
export const downloadFarmersData = async (params, format, token) => {
  try {
    const queryParams = new URLSearchParams(params);
    queryParams.set('ResponseType', format.toUpperCase());

    const url = `${API_BASE_URL}/admin/GetFarmerListWithDetail?${queryParams.toString()}`;

    const res = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'json',
    });

    return res.data;
  } catch (error) {
    console.error(`Download ${format} failed:`, error?.response?.data || error.message);
    throw error;
  }
};

export const addTrainer = async (token, payload) => {
  const res = await axiosInstance.post(`${API_BASE_URL}/admin/UpdateTrainerMode`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getFarmerData = async (token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/admin/AdminDashBoard`,
      {
        params: {
          FromDate: fromDate,
          ToDate: toDate
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get farmer data failed:", error?.response?.data || error.message);
    throw error;
  }
};

export const getCountries = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/country`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(res);
  return res.data || [];
};

export const addCountry = async (formData, token) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/country`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.log("Country added failed:", error?.response?.data);
    throw error;
  }
};

export const updateCountry = async (id, formData, token) => {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/country/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.log("Country update failed:", error?.response?.data);
    throw error;
  }
};

export const uploadCountryGeography = async (id, formData, token, onProgress) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/country/${id}/geography`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    console.log("Geography upload failed:", error?.response?.data);
    throw error;
  }
};

// Crop Wise Pre/Post Sowing Activities APIs
export const getCropWisePrePostList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/crop/cropShowing`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    // console.log("hisi", response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getCropPrePostActivities = async (token, cropId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/crop/cropShowing/${cropId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addCropWisePrePost = async (token, payload) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/crop/cropShowing`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateCropWisePrePost = async (token, payload) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/crop/cropShowing`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteCropWisePrePost = async (token, cropId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/crop/cropShowing/${cropId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addCropWiseCommonInfo = async (token, formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/cropwisecommoninfo`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update Crop Wise Common Information
export const updateCropWiseCommonInfo = async (token, formData, id) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/cropwisecommoninfo/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all Crop Wise Common Information
export const getCropWiseCommonInfo = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/cropwisecommoninfo`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete Crop Wise Common Information
export const deleteCropWiseCommonInfo = async (token, id) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/cropwisecommoninfo/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const getAllCampaigns = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/admin/CampaignMaster/GetList`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const getCampaignById = async (campaignId, token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/admin/CampaignMaster/GetByID/${campaignId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const addCampaign = async (formData, token) => {
  const res = await axiosInstance.post(`${API_BASE_URL}/admin/CampaignMaster/Insert`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const updateCampaign = async (campaignId, formData, token) => {
  const res = await axiosInstance.put(`${API_BASE_URL}/admin/CampaignMaster/Update/${campaignId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const deleteCampaign = async (campaignId, token) => {
  const res = await axiosInstance.delete(`${API_BASE_URL}/admin/CampaignMaster/Delete/${campaignId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const getPages = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/admin/pages`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const uploadBannerImage = async (file, token) => {
  const formData = new FormData();
  formData.append('bannerImage', file);

  const res = await axiosInstance.post(`${API_BASE_URL}/upload-banner`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};

export const getCropShort = async (token) => {
  const res = await axiosInstance.get(`${API_BASE_URL}/crop/getCropShort`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
}

// Notification API functions
export const getAllNotifications = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/Notifications`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

export const createNotification = async (data, token) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/Notification/Create`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating notification:', error);
    throw error;
  }
};

export const checkFarmerExists = async (data, token) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/Notification/checkFarmer`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error checking farmer:', error);
    throw error;
  }
};

export const getFarmersFamilyInfo = async (farmerId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/FarmersFamilyInfo/GetByFarmerID/${farmerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching family info:', error);
    throw error;
  }
};

// Livestock multilingual master/detail APIs
export const getLivestock = async (token) => {
  const response = await axiosInstance.get(`${API_BASE_URL}/livestock`, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return response.data;
};

export const addLivestock = async (token, formData) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/livestock`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateLivestock = async (token, id, formData) => {
  const response = await axiosInstance.put(`${API_BASE_URL}/livestock/${id}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteLivestock = async (token, id) => {
  const response = await axiosInstance.delete(`${API_BASE_URL}/livestock/${id}`, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return response.data;
};

export const getCountryAndLanguage = async (token) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/geography/GetCountryAndLanguage`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const getProvincesByCountry = async (countryId, token) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/geography/GetProvinceOrStates/${countryId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const getDistrictsByProvince = async (provinceId, token) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/geography/GetDistricts/${provinceId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

// 1. Initial Geography Upload (Insert Only)
// export const uploadCountryGeography = async (countryId, formData, token) => {
//   const res = await axiosInstance.post(
//     `${API_BASE_URL}/country/${countryId}/geography`,
//     formData,
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );
//   return res.data;
// };

// 2. Export / Download Complete Existing Country Geography Excel
export const exportCountryGeography = async (countryId, token) => {
  const authToken = token || localStorage.getItem("token") || localStorage.getItem("authToken");
  const res = await axiosInstance.get(
    `${API_BASE_URL}/country/${countryId}/geography/export`,
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      responseType: "blob", // Important for receiving binary Excel file
    }
  );
  return res.data;
};

// 3. Update / Sync Geography from Modified Excel File (with Auto-Backup)
export const updateCountryGeography = async (countryId, formData, token, onProgress) => {
  const res = await axiosInstance.put(
    `${API_BASE_URL}/country/${countryId}/geography`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

// Check Geography Job Status
export const getGeographyJobStatus = async (jobId, token) => {
  const authToken = token || localStorage.getItem("token") || localStorage.getItem("authToken");
  const res = await axiosInstance.get(
    `${API_BASE_URL}/country/geography/job/${jobId}`,
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    }
  );
  return res.data;
};

// Get Latest Geography Job for a Country
export const getLatestGeographyJobForCountry = async (countryId, token) => {
  const authToken = token || localStorage.getItem("token") || localStorage.getItem("authToken");
  const res = await axiosInstance.get(
    `${API_BASE_URL}/country/${countryId}/geography/latest-job`,
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    }
  );
  return res.data;
};

// 4. Revert Geography Data from Backup Snapshot
export const revertCountryGeography = async (countryId, token) => {
  const authToken = token || localStorage.getItem("token") || localStorage.getItem("authToken");
  const res = await axiosInstance.post(
    `${API_BASE_URL}/country/${countryId}/geography/revert`,
    {},
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    }
  );
  return res.data;
};

export const getCommunesByDistrict = async (districtId, token) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/geography/GetCommunes/${districtId}`,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
};

export const getVillagesByCommune = async (communeId, token) => {
  const res = await axiosInstance.get(
    `${API_BASE_URL}/geography/GetVillages/${communeId}`,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
};

// ==========================================
// Geographical Soil Master APIs
// ==========================================
export const getSoilMasterMetadata = async (token) => {
  try {
    const res = await axiosInstance.get(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/metadata`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return res.data;
  } catch (err) {
    try {
      const fallbackRes = await axiosInstance.get(
        `${API_BASE_URL}/geographical-soil/metadata`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      return fallbackRes.data;
    } catch {
      return {
        status: "success",
        data: {
          levels: [
            { level_type: 1, name: "Country" },
            { level_type: 2, name: "Province" },
            { level_type: 3, name: "District" },
            { level_type: 4, name: "Commune" },
            { level_type: 5, name: "Village" },
          ],
          textures: [
            "Sand", "Loamy Sand", "Sandy Loam", "Loam", "Silt Loam", "Silt",
            "Sandy Clay Loam", "Clay Loam", "Silty Clay Loam", "Sandy Clay",
            "Silty Clay", "Clay"
          ],
        },
      };
    }
  }
};

export const getAllGeographicalSoil = async (params = {}, token) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== "") {
      query.append(key, val);
    }
  });
  const queryString = query.toString() ? `?${query.toString()}` : "";

  try {
    const res = await axiosInstance.get(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/GetList${queryString}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return res.data;
  } catch (err) {
    const fallbackRes = await axiosInstance.get(
      `${API_BASE_URL}/geographical-soil${queryString}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return fallbackRes.data;
  }
};

export const getGeographicalSoilById = async (id, token) => {
  try {
    const res = await axiosInstance.get(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/GetByID/${id}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return res.data;
  } catch (err) {
    const fallbackRes = await axiosInstance.get(
      `${API_BASE_URL}/geographical-soil/${id}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return fallbackRes.data;
  }
};

export const getGeographicalSoilByLevel = async (level_type, level_id, token) => {
  try {
    const res = await axiosInstance.get(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/GetByGeography/${level_type}/${level_id}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return res.data;
  } catch (err) {
    const fallbackRes = await axiosInstance.get(
      `${API_BASE_URL}/geographical-soil/by-geography/${level_type}/${level_id}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return fallbackRes.data;
  }
};

export const createGeographicalSoil = async (payload, token) => {
  try {
    const res = await axiosInstance.post(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/Insert`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      const fallbackRes = await axiosInstance.post(
        `${API_BASE_URL}/geographical-soil`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      return fallbackRes.data;
    }
    throw err;
  }
};

export const updateGeographicalSoil = async (id, payload, token) => {
  try {
    const res = await axiosInstance.put(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/Update/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      const fallbackRes = await axiosInstance.put(
        `${API_BASE_URL}/geographical-soil/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      return fallbackRes.data;
    }
    throw err;
  }
};

export const deleteGeographicalSoil = async (id, token) => {
  try {
    const res = await axiosInstance.delete(
      `${API_BASE_URL}/admin/GeographicalSoilMaster/Delete/${id}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      const fallbackRes = await axiosInstance.delete(
        `${API_BASE_URL}/geographical-soil/${id}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      return fallbackRes.data;
    }
    throw err;
  }
};

// ==================== Crop Variety Phase-wise Nutritive Value APIs ====================

export const getNutrientCrops = async (token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/crop-nutrient/crops`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getNutrientVarietiesByCrop = async (cropId, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/crop-nutrient/varieties/${cropId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getNutrientPhases = async (token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/crop-nutrient/phases`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getVarietyNutrientRequirements = async (varietyId, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/crop-nutrient/variety-nutrients/${varietyId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const saveVarietyNutrientRequirements = async (payload, token) => {
  try {
    const res = await axiosInstance.post(`${API_BASE_URL}/crop-nutrient/save`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const exportNutrientsExcel = async (payload, token) => {
  try {
    const res = await axiosInstance.post(`${API_BASE_URL}/crop-nutrient/export-excel`, payload, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const importNutrientsExcel = async (formData, token) => {
  try {
    const res = await axiosInstance.post(`${API_BASE_URL}/crop-nutrient/import-excel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

// ==================== Fertilizer Master APIs ====================

export const getFertilizerMetadata = async (token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/fertilizer-master/metadata`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getAllFertilizers = async (params = {}, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/fertilizer-master`, {
      params,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getFertilizerById = async (id, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/fertilizer-master/${id}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const createFertilizer = async (payload, token) => {
  try {
    const res = await axiosInstance.post(`${API_BASE_URL}/fertilizer-master`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updateFertilizer = async (id, payload, token) => {
  try {
    const res = await axiosInstance.put(`${API_BASE_URL}/fertilizer-master/${id}`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteFertilizer = async (id, token) => {
  try {
    const res = await axiosInstance.delete(`${API_BASE_URL}/fertilizer-master/${id}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getFertilizerBackups = async (id, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/fertilizer-master/${id}/backups`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getCropWiseNutrientList = async (id, token) => {
  try {
    const res = await axiosInstance.get(`${API_BASE_URL}/crop-nutrient/crops-with-nutrients`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};